import React from 'react';

import { Box, H1, Link, Text } from '@betterment/samba-react';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';

import { Header } from './Header';

import CheckmarkIcon from '../../images/goal_portfolio_images/custom_path_light.svg';

export const ConfirmAccount: React.FC<{ logoUrl?: string; isSoloFourOhOneKPlanOwner: boolean }> = ({
  logoUrl,
  isSoloFourOhOneKPlanOwner,
}) => {
  const [params] = useSearchParams();

  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Header logoUrl={logoUrl} progress={50} title="Review accounts" />
      <Box
        css={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: 'space.400',
          paddingTop: 'space.800',
        }}
      >
        <Box
          css={{
            marginBottom: 'space.400',
          }}
        >
          <img style={{ width: 64 }} src={CheckmarkIcon} alt="Checkmark in a circle" />
        </Box>

        <Box css={{ textAlign: 'center', pb: 'space.800' }}>
          <H1
            variant="pageTitle"
            css={{
              marginBottom: 'space.150',
              color: 'text.DEFAULT',
            }}
          >
            Finish setting up your solo 401(k) plan
          </H1>
          <Text
            css={{
              fontSize: 'fontSize.100',
              color: 'text.DEFAULT',
              lineHeight: 'lineHeights.normal',
            }}
          >
            Your advisor initiated the process of opening a new Solo 401(k) plan for you. Review and confirm account
            details to complete the process.
          </Text>

          <br />

          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <Link asChild={true} variant="solidPrimary" css={{ marginTop: 'space.400' }}>
            <RouterLink
              to={`/accept_solo_401k/${isSoloFourOhOneKPlanOwner ? 'sign_document' : 'account_agreements'}?invitation_token=${params.get('invitation_token')}`}
            >
              Continue
            </RouterLink>
          </Link>
        </Box>
      </Box>
    </Box>
  );
};
